import { render, staticRenderFns } from "./EmptySearchMessage.vue?vue&type=template&id=6f38613e"
import script from "./EmptySearchMessage.vue?vue&type=script&lang=js"
export * from "./EmptySearchMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports